import { Routes } from '@angular/router';

import { CatalogComponent } from './catalog.component';

export const catalogRoute: Routes = [
    {
        path: 'product-catalog/card-type',
        component: CatalogComponent,
        data: {
            pageTitle: 'jYoguiApp.cardType.home.title'
        }
    },
];





// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/catalog/catalog.route.ts